import * as React from 'react';
import { Icon } from '../Icon';
import { Link } from 'react-router-dom';

export interface SubNavProps {
    dataTarget: string;
    text: string;
    iconToggleShow: string;
    iconToggleHide: string;
    children?: any;
    className?: string;
    id?: string;
}

class SubNav extends React.Component<SubNavProps,
    any> {

    private _timeout: any;

    constructor(props: SubNavProps) {
        super(props);

        this.state = {
            isHidden: true,
            isDoneAnimating: true
        };
        this.toggleMenu = this
            .toggleMenu
            .bind(this);
        this.setDoneAnimating = this
            .setDoneAnimating
            .bind(this);
    }

    public get timeout(): any { return this._timeout; }
    public set timeout(v: any) {
        this._timeout = v;
    }

    toggleMenu() {
        if (this.state.isDoneAnimating) {
            this.setState({
                isHidden: !this.state.isHidden,
                isDoneAnimating: false
            });
        }
    }

    setDoneAnimating() {
        this.setState({ isDoneAnimating: true });
    }
    
    render() {
        let self = this;
        clearTimeout(this.timeout);
        if (!this.state.isDoneAnimating) {
            this.timeout = setTimeout(() => {
                self.setDoneAnimating();
            }, 350);
        }

        let className = this.props.className !== undefined
            ? this.props.className
            : '';
        className = className + ' subNavListItem';
        let dataTarget = '#' + this.props.dataTarget;

        let icon = null;
        if (this.state.isHidden) {
            icon = (
                <Link
                    className='navicon'
                    to='#'
                    data-toggle='collapse'
                    data-target={dataTarget}
                    aria-expanded='false'
                >
                    <Icon name={this.props.iconToggleShow} onClick={this.toggleMenu} />
                </Link>
            );

        } else {
            icon = (
                <Link
                    className='navicon'
                    to='#'
                    data-toggle='collapse'
                    data-target={dataTarget}
                    aria-expanded='false'
                >
                    <Icon name={this.props.iconToggleHide} onClick={this.toggleMenu} />
                </Link>
            );
        }

        return (
            <li id={this.props.id} className={className} onClick={this.toggleMenu}>
                <Link
                    to='#'
                    data-toggle='collapse'
                    data-target={dataTarget}
                    aria-expanded='false'
                >
                    {this.props.text}
                </Link>
                {icon}

                <ul className='nav collapse' id={this.props.dataTarget} role='menu'>
                    {this.props.children}
                </ul>
            </li>
        );
    }
}

export default SubNav;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/bootstrap-components/SubNav.tsx